(function (angular) {
    angular.module('shared').service('$Config', function (localStorageService) {
        var config = window.config;
        config.eventsV2 = function () {
            var user = localStorageService.get("user");
            return user.Email === "pdg@netika.com";
        };
        config.getVersion = function(){
            let pattern = config.version.split(" ");
            return pattern[0].trim();
        }
        return config;
    });
}(angular));